import type { RouterConfig } from 'nuxt/schema'

export default <RouterConfig>{
    // layouts/default.vue smooth-scrolls to the top on path changes; Nuxt's default
    // scrollBehavior would jump there as well.
    scrollBehavior: () => false,
}
